export const LIVE_INFO = 'LIVE_INFO';
export const LESSON_INFO = 'LESSON_INFO';
export const REVIEW_INFO = 'REVIEW_INFO';
export const UPDATE_SUBJECTIDS = 'UPDATE_SUBJECTIDS';
export const UPDATE_TEACHER_DISABLED = 'UPDATE_TEACHER_DISABLED';
